<template>
  <div v-if="show" class="toast">
    {{ message }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: ""
    };
  },
  methods: {
    showToast(message) {
      this.message = message;
      this.show = true;

      setTimeout(() => {
        this.hideToast();
      }, 3000);
    },
    hideToast() {
      this.show = false;
      this.message = "";
    }
  }
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  z-index: 9999;
}
</style>
